module.exports = __webpack_public_path__ + "img/viviana.1e1653b8.png";